<template>
  <div id="wrapper" v-if="timeoff_request_read">
    <div id="content-wrapper" style="">
      <!-- #region TITLE TIME-OFF HISTORY -->
      <div class="time_off_history_header">
        <div
          class=""
          style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px; padding-left: 0px; background-color: #2c2c2c; border-radius: 0.3rem;"
        >
          <router-link
            v-if="auth != null && timeoff_management"
            :to="`/time_off_management`"
            tag="button"
            class="btn-sm border-0 button--pandora"
            style="width: 90px; padding: 4px 2px 4px 4px;"
          >
            <i
              class="fas fa-arrow-alt-circle-left "
              style="float: left; font-size: 23px;"
            ></i
            >Back</router-link
          >
        </div>
        <div
          class=""
          style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px; padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem;"
        >
          <router-link
            v-if="auth != null && timeoff_request_create"
            :to="`/time_off_request/${this.auth.name}/create`"
            tag="button"
            class="btn-sm border-0 button--pandora"
            style="width: 90px; padding: 4px 2px 4px 4px;"
          >
            <i
              class="fas fa-plus-circle"
              style="float: left; font-size: 23px;"
            ></i
            >Create</router-link
          >
        </div>
      </div>
      <!--#endregion -->

      <!-- #region TIME-OFF HISTORY -->
      <div id="time_off_history_fluid" class="container-fluid">
        <div class="time_off_history">
          <div class="justify-content-start" style="height: 100%;">
            <!-- #region Employee Time-off Information Table -->
            <b-row class="" style="padding: 0px; margin: 0px;">
              <b-col cols="12" style="padding:0px; float: left;">
                <div
                  style="border: 0px solid #ddd; border-radius: 5px 5px 0px 0px; background: #c8c8c8; height: 50px;  justify-content: center; align-items: center; display: flex;"
                >
                  <img
                    id="megroup_logo"
                    src="../assets/Logo/MeGroup_logo_Black.png"
                    class="d-inline-block align-top"
                    alt="MeGroup"
                    width="50px"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row
              class=""
              style="padding: 0px; margin: 0px; border: 1px solid #c9f3fb; background: #c9f3fb;"
            >
              <b-col cols="8" align-self="center" style="padding: 42px 0px;">
                <p
                  style="margin:3px 0 3px 12px; font-weight:700; font-size:20px;  color:#666666"
                >
                  Hi
                  {{
                    formatGenderAndFullName(
                      employee.gioitinh,
                      employee.hovaten,
                      employee.employeeEnName
                    )
                  }}
                </p>
                <p
                  style="margin:3px 0 3px 12px; font-weight:700; font-size:20px;  color:#666666"
                >
                  Have a great {{ getDayOfWeek() }}!
                </p>
              </b-col>
              <b-col
                cols="4"
                align-self="end"
                style="padding:0px; float: right;"
              >
                <div style=" height: 154px;">
                  <img
                    id="email_header"
                    naturalheight="280"
                    naturalwidth="280"
                    src="../assets/email_header_img.png"
                    width="150"
                    style="margin-top: 4px; display: block; border: 0px; outline: none; text-decoration: none; float: right;"
                    crossorigin="anonymous"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row
              class=""
              style="background-color: #efefef; padding: 16px; margin: 0px; border: 0px solid #ddd; border-radius: 0px 0px 5px 5px;"
            >
              <b-col cols="12" style="padding:0px; margin:0px;">
                <b-row
                  class=""
                  style="padding: 0px; margin: 0px; background-color: #B4D7F2; border: 0px solid #B4D7F2; border-radius: 5px 5px 0px 0px;"
                >
                  <b-col cols="12" align-self="start" style="padding:0px;">
                    <p
                      style="margin:0px; padding:16px; font-weight:700; font-size:20px; color:#666666"
                    >
                      Here is a summary of your time off
                    </p>
                  </b-col>
                </b-row>
                <b-row
                  class=""
                  style="padding: 0px; margin: 0px; background-color: #fff; border: 0px solid #fff; border-radius: 0px 0px 5px 5px;"
                >
                  <b-col id="user_profile_col" cols="2" align-self="center">
                    <!-- src="../assets/User_font_awesome.png" -->
                    <img
                      v-show="is_loaded_avatar"
                      id="user_profile"
                      naturalheight="100"
                      naturalwidth="100"
                      :src="employee.employeeAvatarPath"
                      title="User_avatar"
                      alt="User_avatar"
                      @load="onLoadAvatar"
                      style="max-width:170px; width: 100%; height: auto;"
                    />
                    <img
                      v-show="!is_loaded_avatar"
                      id="user_profile"
                      naturalheight="100"
                      naturalwidth="100"
                      src="../assets/User_font_awesome.png"
                      title="User_awesome"
                      alt="User_awesome"
                      height="170"
                    />
                  </b-col>
                  <b-col id="timeoff_profile_col" cols="10">
                    <b-row style="margin:0px;">
                      <b-col id="timeoff_label_profile_col" cols="5">
                        Remaining time-off Days from
                        {{ new Date().getFullYear() - 1 }}
                      </b-col>
                      <b-col id="timeoff_value_profile_col" cols="7">
                        {{ employee.lastyearRemainDays }}
                      </b-col>
                    </b-row>
                    <b-row style="margin:0px;">
                      <b-col
                        id="timeoff_label_profile_col"
                        cols="5"
                        align-self="end"
                      >
                        Taken time-off days
                        {{ new Date().getFullYear() - 1 }}/Expired by 31/03/{{
                          new Date().getFullYear()
                        }}
                      </b-col>
                      <b-col
                        id="timeoff_value_profile_col"
                        cols="7"
                        align-self="end"
                      >
                        {{ employee.lastyearUsedDays }}/{{
                          employee.lastyearRemainDays -
                            employee.lastyearUsedDays
                        }}
                      </b-col>
                    </b-row>
                    <b-row style="margin:0px;">
                      <b-col
                        id="timeoff_label_profile_col"
                        cols="5"
                        align-self="end"
                      >
                        Total time-off days in
                        {{ new Date().getFullYear() }}
                      </b-col>
                      <b-col
                        id="timeoff_value_profile_col"
                        cols="7"
                        align-self="end"
                      >
                        {{ employee.timeOffDays }}
                      </b-col>
                    </b-row>
                    <b-row style="margin:0px;">
                      <b-col
                        id="timeoff_label_profile_col"
                        cols="5"
                        align-self="end"
                      >
                        Time-off Days Used in {{ new Date().getFullYear() }}
                      </b-col>
                      <b-col
                        id="timeoff_value_profile_col"
                        cols="7"
                        align-self="end"
                      >
                        {{ employee.usedDays - employee.lastyearUsedDays }}
                      </b-col>
                    </b-row>
                    <b-row style="margin:0px;">
                      <b-col
                        id="timeoff_label_profile_col"
                        cols="5"
                        align-self="end"
                        style="font-weight: 600;"
                      >
                        Remaining Time-off Days
                      </b-col>
                      <b-col
                        id="timeoff_value_profile_col"
                        cols="7"
                        align-self="end"
                        style="font-weight: 600;"
                      >
                        {{ employee.remainDays }}
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <!--#endregion -->

            <!-- #region Commented -->
            <!-- <b-row class="" style="padding: 0px 0px 10px 0px; margin: 0px;">
              <b-col cols="12" style="padding:0px; float: left;">
                <div
                  style="border: 1px solid #ddd; border-top: 0px; border-radius: 0px 0px 5px 5px; background: #f8f9fa; height: 100%;"
                >
                  <b-row
                    class=""
                    style="padding: 20px 10px 0px 10px; margin: 0px;"
                  >
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="4"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Full Name
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.hovaten"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="6"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Time-off days in {{ new Date().getFullYear() - 1 }}
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.lastyearRemainDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 5px 10px 0px 10px; margin: 0px;"
                  >
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="4"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Code
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.manhanvien"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="6"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Time-off days in {{ new Date().getFullYear() }}
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.timeOffDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 5px 10px 0px 10px; margin: 0px;"
                  >
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                    </b-col>
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="6"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Time-off days used
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.usedDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 5px 10px 0px 10px; margin: 0px;"
                  >
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                    </b-col>
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="6"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Remaining Time-off
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.remainDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row
                    class=""
                    style="padding: 5px 10px 20px 10px; margin: 0px;"
                  >
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                    </b-col>
                    <b-col
                      cols="6"
                      style="padding-right: 5px; padding-left: 5px;"
                    >
                      <b-form-group
                        label-cols-sm="6"
                        label-align-sm="left"
                        style="margin-bottom: 0px;"
                      >
                        <template v-slot:label>
                          Time-off days used in
                          {{ new Date().getFullYear() - 1 }}
                        </template>
                        <b-form-input
                          type="text"
                          size="sm"
                          v-model="employee.lastyearUsedDays"
                          disabled
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col cols="5" style="float: right;">
                <div
                  style="border: 1px solid #ddd; border-radius: 5px; background: #f8f9fa; height: 100%;"
                >
                  <b-row class="" style="padding: 20px 0 10px 0; margin: 0px;">
                    <b-col></b-col>
                    <b-col
                      style="width:100px; min-width:100px;  max-width:100px; padding-right: 0px; padding-left: 0px;"
                    >
                      <div
                        style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem; float:right;  margin-right: 10px;"
                      >
                        <router-link
                          v-if="auth != null && timeoff_request_read"
                          :to="`/time_off_request/${this.auth.name}/create`"
                          tag="button"
                          class="btn-sm border-0 button--pandora"
                          style="width: 90px; padding: 4px 2px 4px 4px;"
                        >
                          <i
                            class="fas fa-plus-circle"
                            style="float: left; font-size: 23px;"
                          ></i
                          >Create</router-link
                        >
                      </div>
                    </b-col>
                    <b-col
                      style="width:55px; min-width:55px; max-width:55px; padding-right: 0px; padding-left: 0px;"
                    >
                      <div
                        style="width: 45px; min-width: 45px; max-width: 45px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem; margin-right: 10px;"
                      >
                        <button
                          class="btn-sm border-0 button--pandora"
                          style="width: 45px; padding: 3px 4px 3px 4px;"
                        >
                          <i
                            class="fas fa-sync-alt"
                            style="font-size: 23px;"
                          ></i>
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 10px 0; margin: 0px;">
                    <b-col class="col-6">
                      <b-form-group
                        label-align-sm="left"
                        style="margin-bottom:0px;"
                      >
                        <template v-slot:label>
                          From Date
                        </template>
                        <master-date-picker
                          v-model="from_date_picker"
                        ></master-date-picker>
                      </b-form-group>
                    </b-col>
                    <b-col class="col-6">
                      <b-form-group
                        label-align-sm="left"
                        style="margin-bottom:0px;"
                      >
                        <template v-slot:label>
                          To Date
                        </template>
                        <master-date-picker
                          v-model="to_date_picker"
                        ></master-date-picker>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 10px 0; margin: 0px;">
                    <b-col class="col-6">
                      <b-form-group
                        label-align-sm="left"
                        style="margin-bottom:0px;"
                      >
                        <template v-slot:label>
                          Time-off type
                        </template>
                        <b-form-select
                          size="sm"
                          v-model="timeoff_type_search"
                          :options="timeOffTypeList"
                          value-field="id"
                          text-field="pickListValue"
                          required
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col class="col-6">
                      <b-form-group
                        label-align-sm="left"
                        style="margin-bottom:0px;"
                      >
                        <template v-slot:label>
                          Time-off status
                        </template>
                        <b-form-select
                          size="sm"
                          v-model="timeoff_status_search"
                          :options="timeOffStatusList"
                          value-field="id"
                          text-field="pickListValue"
                          required
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="" style="padding: 20px 0 10px 0; margin: 0px;">
                    <b-col></b-col>
                    <b-col
                      style="width:100px; min-width:100px;  max-width:100px; padding-right: 0px; padding-left: 0px;"
                    >
                      <div
                        style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px; padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem; float:right; margin-right: 10px;"
                      >
                        <button
                          class="btn-sm border-0 button--pandora"
                          style="width: 90px; float: right; padding: 4px 2px 4px 4px;"
                          @click.prevent="searchTimeOffHistory"
                        >
                          <i
                            class="fas fa-search"
                            style="float: left; font-size: 23px;"
                          ></i>
                          Search
                        </button>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row> -->
            <!-- <b-row class="" style="padding: 20px 0 10px 0; margin: 0px;">
              <b-col></b-col>
              <b-col
                style="width:100px; min-width:100px;  max-width:100px; padding-right: 0px; padding-left: 0px;"
              >
                <div
                  style="width: 90px; min-width: 90px; max-width: 90px; padding-right: 0px;padding-left: 0px; background-color: #2c2c2c; border-radius: 0.2rem; float:right;  margin-right: 10px;"
                >
                  <router-link
                    v-if="auth != null && timeoff_request_read"
                    :to="`/time_off_request/${this.auth.name}/create`"
                    tag="button"
                    class="btn-sm border-0 button--pandora"
                    style="width: 90px; padding: 4px 2px 4px 4px;"
                  >
                    <i
                      class="fas fa-plus-circle"
                      style="float: left; font-size: 23px;"
                    ></i
                    >Create</router-link
                  >
                </div>
              </b-col>
            </b-row> -->
            <!-- #endregion -->

            <!-- #region Time-off history Table -->
            <b-row class="" style="padding: 7px 0px 10px 0px; margin: 0px;">
              <b-col cols="12" style="float: right; padding:0px;">
                <b-table
                  id="my-table"
                  bordered
                  head-variant="dark"
                  hover
                  responsive
                  striped
                  small
                  :fields="time_off_history_fields"
                  :items="employeeTimeOffRequests"
                  table-variant="light"
                >
                  <template #cell(STT)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template v-slot:cell(timeOffCreator)="data">{{
                    data.item.timeOffCreator
                  }}</template>
                  <template v-slot:cell(fromDate)="data">{{
                    $convert_date_string(data.item.fromDate)
                  }}</template>
                  <template v-slot:cell(toDate)="data">{{
                    $convert_date_string(data.item.toDate)
                  }}</template>
                  <template v-slot:cell(numOfTimeOff)="data">{{
                    data.item.numOfTimeOff
                  }}</template>
                  <template v-slot:cell(reason)="data">{{
                    data.item.reason
                  }}</template>
                  <template v-slot:cell(taskduringwfh)="data">{{
                    data.item.taskduringwfh
                  }}</template>
                  <template v-slot:cell(timeOffType)="data">
                    <b-badge
                      :variant="setVariantByTimeOffType(data.item.timeOffType)"
                      style="width: 116px; white-space: pre-wrap;"
                    >
                      {{
                        findTimeOffType(timeOffTypeList, data.item.timeOffType)
                      }}</b-badge
                    >
                  </template>
                  <template v-slot:cell(timeOffStatus)="data">
                    <b-badge
                      :variant="
                        setVariantByTimeOffStatus(data.item.timeOffStatus)
                      "
                      style="width: 70px; white-space: pre-wrap;"
                    >
                      {{
                        findTimeOffStatus(
                          timeOffStatusList,
                          data.item.timeOffStatus
                        )
                      }}</b-badge
                    >
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <!--#endregion -->
          </div>
        </div>
      </div>
      <!--#endregion -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TimeOffHistory",
  components: {
    // MasterDatePicker,
    // TimeOffHistory,
    // VueDatepickerLocal,
  },
  data() {
    return {
      time_off_history_fields: [
        {
          key: "STT",
          label: "No.",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
          tdClass: "text-right",
        },
        // {
        //   key: "Department",
        //   label: "Department",
        //   stickyColumn: true,
        // },
        // {
        //   key: "timeOffCreator",
        //   label: "Time-off creator",
        //   thClass: "align-middle",
        //   thStyle: {
        //     width: "280px",
        //     minWidth: "280px",
        //     maxWidth: "280px",
        //     textAlign: "center",
        //   },
        // },
        {
          key: "fromDate",
          label: "From Date",
          thClass: "align-middle",
          thStyle: {
            width: "105px",
            minWidth: "105px",
            maxWidth: "105px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "toDate",
          label: "To Date",
          thClass: "align-middle",
          thStyle: {
            width: "105px",
            minWidth: "105px",
            maxWidth: "105px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "numOfTimeOff",
          label: "Days",
          thClass: "align-middle",
          thStyle: {
            width: "60px",
            minWidth: "60px",
            maxWidth: "60px",
            textAlign: "center",
          },
          tdClass: "text-right",
        },
        {
          key: "reason",
          label: "Reason/Note",
          thClass: "align-middle",
          thStyle: {
            width: "280px",
            minWidth: "280px",
            textAlign: "center",
          },
        },
        {
          key: "taskduringwfh",
          label: "Task During WFH",
          thClass: "align-middle",
          thStyle: {
            width: "auto",
            minWidth: "280px",
            textAlign: "center",
          },
        },
        {
          key: "timeOffType",
          label: "Type",
          thClass: "align-middle",
          thStyle: {
            width: "130px",
            minWidth: "130px",
            maxWidth: "130px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        {
          key: "timeOffStatus",
          label: "Status",
          thClass: "align-middle",
          thStyle: {
            width: "90px",
            minWidth: "90px",
            maxWidth: "90px",
            textAlign: "center",
          },
          tdClass: "text-center",
        },
        // {
        //   key: "function",
        //   label: "",
        // },
      ],
      from_date_picker: "",
      to_date_picker: "",
      timeoff_type_search: "",
      timeoff_status_search: "",
      // created_date_picker: "",
      // holidayColorItems: [],
      employee: {
        employeeId: 0,
        departmentId: 0,
        lineManager: "",
        lineManagerId: 0,
        manhanvien: "",
        employeeAvatarPath: "",
        hovaten: "",
        employeeEnName: "",
        gioitinh: "",
        email: null,
        usedDays: 0,
        remainDays: 0,
        timeOffDays: 0,
        lastyearUsedDays: 0,
        lastyearRemainDays: 0,
        // donvicongtac: null,
        vitricongviec: null,
        tinhtranghoso: null,
      },
      employeeTimeOffRequests: [],

      timeOffTypeList: [],
      //vitricongviecs: [],
      tinhtranghosos: [],
      timeOffStatusList: [
        {
          id: null,
          pickListType: "tinhtrangduyet",
          pickListValue: "All",
        },
        {
          id: 0,
          pickListType: "tinhtrangduyet",
          pickListValue: "Awaiting approval",
        },
        {
          id: 1,
          pickListType: "tinhtrangduyet",
          pickListValue: "Approved",
        },
        {
          id: 2,
          pickListType: "tinhtrangduyet",
          pickListValue: "Declined",
        },
      ],
      form_search: {
        timeoff_type: "",
        timeoff_status: "",
        from_date: "",
        to_date: "",
      },
      // departments_list: [],
      // disable_save_button: false,
      is_loaded_avatar: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        // axios.get("/api/department"),
        axios.get(`/api/timeoffrequest/employee/${to.params.slug}`),
        axios.get("/api/picklist?q=loainghiphep|tinhtranghoso"),
        // axios.get("/api/leaveschedule/holidayColor"),
        // axios.get("/api/picklist?q=loainghiphep|vitricongviec|tinhtranghoso"),
      ])
      .then(
        axios.spread((
          /*department,*/ employee,
          picklist /*, holidayColor*/
        ) => {
          next((vm) =>
            vm.initData(
              // department.data,
              employee.data,
              picklist.data,
              // holidayColor.data,
              null // not error
            )
          );
        })
      )
      .catch((err) => {
        next((vm) => vm.initData(null, null, err));
      });
  },
  beforeDestroy() {
    this.cancelRefreshDeviceTable();
  },
  created() {
    this.timer = setInterval(this.refreshDeviceTable, 60000);
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    timeoff_management() {
      return this.$store.getters.hasPermission("timeoff_management");
    },
    timeoff_request_read() {
      return this.$store.getters.hasPermission("timeoff_request_read");
    },
    timeoff_request_create() {
      return this.$store.getters.hasPermission("timeoff_request_create");
    },
    timeoff_request_update() {
      return this.$store.getters.hasPermission("timeoff_request_update");
    },
    timeoff_request_delete() {
      return this.$store.getters.hasPermission("timeoff_request_delete");
    },
  },
  methods: {
    initData(/*department, */ employee, picklists, /* holidayColors, */ err) {
      if (err) {
        this.$toast.error(err.response.data, "Error", { timeout: 10000 });
        // this.disable_save_button = true;
        return;
      }
      // department.forEach((department) => {
      //   // if (department.madonvi != "GS" && department.madonvi != "YL") {
      //   this.departments_list.push(department);
      //   // }
      // });
      this.employee = employee;
      // this.holidayColorItems = holidayColors;
      picklists.forEach((picklist, index) => {
        switch (picklist.pickListType) {
          case "loainghiphep":
            if (picklist.pickListValue == "Phép") {
              this.timeOffTypeList.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Paid leave",
              });
            } else if (picklist.pickListValue == "Nghỉ không lương") {
              this.timeOffTypeList.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: "Unpaid leave",
              });
            } else {
              this.timeOffTypeList.unshift({
                id: picklist.id,
                pickListType: picklist.pickListType,
                pickListValue: picklist.pickListValue,
              });
            }
            break;
          // case "vitricongviec":
          //   this.vitricongviecs.unshift(picklist);
          //   break;
          case "tinhtranghoso":
            this.tinhtranghosos.unshift(picklist);
            break;
        }
      });
      this.timeOffTypeList.unshift({
        id: null,
        pickListType: "loainghiphep",
        pickListValue: "All",
        // pickListValue: "Select Time-off type...",
      });
      this.timeoff_type_search = null;
      this.timeoff_status_search = null;
      // let query = Object.assign({}, this.$route.query);
      // query.q = "";
      axios
        .get(
          `/api/timeoffrequest/employee/${this.employee.employeeId}/tracking`
          // ,{
          //   params: query,
          // }
        )
        .then((res) => {
          this.employeeTimeOffRequests = res.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {
          // this.disable_save_button = false;
        });
    },
    searchTimeOffHistory() {
      this.form_search.timeoff_type = this.timeoff_type_search;
      this.form_search.timeoff_status = this.timeoff_status_search;
      this.form_search.from_date = this.swap_date_format(this.from_date_picker);
      this.form_search.to_date = this.swap_date_format(this.to_date_picker);
      let query = Object.assign({}, this.$route.query);
      query.q = "";
      if (this.form_search.timeoff_type != null)
        query.q += this.form_search.timeoff_type;
      if (this.form_search.timeoff_status != null)
        query.q += "|" + this.form_search.timeoff_status;
      else query.q += "|";
      if (this.form_search.from_date != null)
        query.q += "|" + this.form_search.from_date;
      else query.q += "|";
      if (this.form_search.to_date != null)
        query.q += "|" + this.form_search.to_date;
      else query.q += "|";
      axios
        .get(
          `/api/timeoffrequest/employee/${this.employee.employeeId}/tracking`,
          {
            params: query,
          }
        )
        .then((res) => {
          this.employeeTimeOffRequests = res.data;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {
          // this.disable_save_button = false;
        });
    },
    swap_date_format(date) {
      if (date == null || date == "") return null;
      var date_split = date.split("/");
      return date_split[1] + "/" + date_split[0] + "/" + date_split[2];
    },
    formatGenderAndFullName(gender, fullName, employeeEnName) {
      let formatString = "";
      switch (gender.toUpperCase()) {
        case "NAM":
        case "MALE":
          if (employeeEnName != "" && employeeEnName != null)
            formatString = "Mr. " + employeeEnName;
          else formatString = "Mr. " + fullName;
          break;
        case "NỮ":
        case "FEMALE":
          if (employeeEnName != "" && employeeEnName != null)
            formatString = "Ms. " + employeeEnName;
          else formatString = "Ms. " + fullName;
          break;
        default:
          if (employeeEnName != "" && employeeEnName != null)
            formatString = "Mr/Ms. " + employeeEnName;
          else formatString = "Mr/Ms. " + fullName;
          break;
      }
      return formatString;
    },
    getDayOfWeek() {
      const weekday = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      const d = new Date();
      return weekday[d.getDay()];
    },
    findTimeOffType(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findTimeOffStatus(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    setVariantByTimeOffType(value) {
      var variant = "primary";
      switch (value) {
        case this.$timeoff_type_paidleave:
          variant = "warning";
          break;
        case this.$timeoff_type_unpaidleave:
          variant = "success";
          break;
        case this.$timeoff_type_workfromhome:
          variant = "info";
          break;
        case this.$timeoff_type_statutoryleave:
          variant = "secondary";
          break;
      }
      return variant;
    },
    setVariantByTimeOffStatus(value) {
      var variant = "info";
      switch (value) {
        case this.$timeoff_status_awaiting_approval:
          variant = "primary";
          break;
        case this.$timeoff_status_approved:
          variant = "success";
          break;
        case this.$timeoff_status_declined:
          variant = "danger";
          break;
      }
      return variant;
    },
    onLoadAvatar() {
      this.is_loaded_avatar = true;
    },
    refreshDeviceTable() {
      var temp = window.scrollY;
      // let query = Object.assign({}, this.$route.query);
      axios
        .get(
          `/api/timeoffrequest/employee/${this.employee.employeeId}/tracking`
          // ,{
          //   params: query,
          // }
        )
        .then((res) => {
          this.employeeTimeOffRequests = res.data;
        })
        .catch((err) => {
          // this.$toast.error(err.response.data, "Error", { timeout: 3000 });
        })
        .finally(() => {
          window.scrollTo({
            top: temp,
          });
        });
    },
    cancelRefreshDeviceTable() {
      clearInterval(this.timer);
    },
  },
};
</script>
<style scoped>
.time_off_history_header {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin: 8px 16px 16px 16px;
  list-style: none;
  background-color: #fff;
  border-radius: 0.25rem;
  align-self: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.button--pandora {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.button--pandora:hover {
  background-color: #ccc;
}
</style>
<style>
#time_off_history_fluid .time_off_history {
  padding: 15px;
  color: #000;
  border-radius: 10px;
  background-color: #fff;
  width: 1230px;
  margin: auto;
}

#time_off_history_fluid.container-fluid {
  height: calc(100% - 80px);
  overflow: auto;
}

#time_off_history_fluid .form-control-sm {
  font-size: 1rem;
}

#time_off_history_fluid .b-table-sticky-header {
  height: calc(100vh - 555px);
  max-height: unset;
  min-height: 250px;
}

/*#region Employee Time-off Information Table*/
img#user_profile {
  display: block;
  outline: none;
  text-decoration: none;
}

#user_profile_col {
  padding: 0px;
  font-size: 0px;
  float: left;
  width: 100px;
  margin: 0px;
  flex: 0 0 170px;
  max-width: 170px;
}

#timeoff_profile_col {
  padding: 0px;
  float: right;
  color: #666;
  margin: 15px 10px;
  flex: 0 0 calc(100% - 190px);
  max-width: calc(100% - 190px);
}

#timeoff_label_profile_col {
  padding: 0px;
  float: left;
  margin: 0px;
  flex: 0 0 360px;
  max-width: 360px;
  border-bottom: 1px solid #fff;
  align-self: end !important;
}

#timeoff_value_profile_col {
  padding: 0px;
  float: right;
  margin: 0px;
  flex: 0 0 calc(100% - 360px);
  max-width: calc(100% - 360px);
  border-bottom: 1px dashed #666;
  align-self: end !important;
}
/*#endregion Employee Time-off Information Table*/

@media (max-width: 700px) {
  img#user_profile {
    display: none;
  }

  #user_profile_col {
    display: none;
    width: 0px;
    flex: 0 0 0px;
    -ms-flex: 0 0 0px;
    -webkit-flex: 0 0 0px;
    max-width: 0px;
  }

  #time_off_history_fluid #timeoff_profile_col {
    flex: 0 0 calc(100% - 20px);
    flex: 0 0 -webkit-calc(100% - 20px);
    flex: 0 0 -moz-calc(100% - 20px);
    max-width: calc(100% - 20px);
    max-width: -webkit-calc(100% - 20px);
    max-width: -moz-calc(100% - 20px);
  }
}

@media (max-width: 500px) {
  #time_off_history_fluid #timeoff_label_profile_col {
    flex: 0 0 calc(100% - 20px);
    flex: 0 0 -webkit-calc(100% - 20px);
    flex: 0 0 -moz-calc(100% - 20px);
    max-width: calc(100% - 20px);
    max-width: -webkit-calc(100% - 20px);
    max-width: -moz-calc(100% - 20px);
  }

  #time_off_history_fluid #timeoff_value_profile_col {
    flex: 0 0 calc(100% - 20px);
    flex: 0 0 -webkit-calc(100% - 20px);
    flex: 0 0 -moz-calc(100% - 20px);
    max-width: calc(100% - 20px);
    max-width: -webkit-calc(100% - 20px);
    max-width: -moz-calc(100% - 20px);
  }
}

@media (max-width: 1270px) {
  #time_off_history_fluid .time_off_history {
    width: 100%;
  }
}

/*#region Scrollbar*/
#time_off_history_fluid::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(109, 118, 126, 0.8);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#time_off_history_fluid::-webkit-scrollbar {
  width: 10px;
  background-color: #f5f5f5;
}

#time_off_history_fluid::-webkit-scrollbar:horizontal {
  height: 10px;
  background-color: #f5f5f5;
}

#time_off_history_fluid::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: hsl(0deg 0% 66%);
}

#time_off_history_fluid::-webkit-scrollbar-thumb:hover {
  box-shadow: inset 0 0 6px rgba(52, 58, 64, 1);
}
/*#endregion Scrollbar*/
</style>
